import { render, staticRenderFns } from "./GVisitorCard.vue?vue&type=template&id=16f13eb0&scoped=true&"
import script from "./GVisitorCard.vue?vue&type=script&lang=ts&"
export * from "./GVisitorCard.vue?vue&type=script&lang=ts&"
import style0 from "./GVisitorCard.vue?vue&type=style&index=0&id=16f13eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f13eb0",
  null
  
)

export default component.exports